import type { LiveDbKey } from './local/liveDbKey'

export type CatalogScope = {
  tenantId: string
  orgId: string
}

export function catalogScope (tenantId: string, orgId: string): CatalogScope | undefined {
  if (!tenantId || !orgId || tenantId === 'undefined' || orgId === 'undefined') {
    return undefined
  }

  return { tenantId, orgId }
}

export function catalogScopeKey (scope: CatalogScope): string {
  return `${scope.tenantId}-${scope.orgId}`
}

export function liveCatalogDbKey (
  tenantId: { readonly value: string },
  orgId: { readonly value: string },
): LiveDbKey {
  return () => {
    const scope = catalogScope(tenantId.value, orgId.value)
    return scope === undefined ? undefined : catalogScopeKey(scope)
  }
}

export function catalogScopeMatches (
  started: CatalogScope | undefined,
  current: CatalogScope | undefined,
): boolean {
  return started !== undefined
    && current !== undefined
    && started.tenantId === current.tenantId
    && started.orgId === current.orgId
}
